import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import { dispatch } from 'store';

import { RootState } from 'types';
import { clearAuthError, createNewPassword } from 'modules/auth/actions';
import { setNotification } from 'modules/app/actions';

import { Input, Button } from 'views/components';
import { AuthLeftBlock } from '../components/AuthLeftBlock';

import styles from './CreateNewPassword.module.css';

import texts from './texts';
import { useQuery, t } from 'utils';

export const CreateNewPassword: FC = () => {
  const token = useQuery().get('token') || '';

  const { errors, loading } = useSelector((state: RootState) => state.auth);
  const { notification, windowWidth } = useSelector((state: RootState) => state.app);

  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  useEffect(() => {
    dispatch(clearAuthError());
  }, [newPassword, setNewPassword]);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  const renderError = () => {
    if (errors && errors.token) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors.token}</p>;
    }
  };

  return (
    <div className={styles.wrap}>
      <AuthLeftBlock title={t(texts.title)} />
      <div className={styles.rightBlock}>
        <div className={styles.rightBlockWrap}>
          {renderError()}
          <Input
            name="password"
            value={newPassword}
            onChange={(e: any) => setNewPassword(e.target.value)}
            label={t(texts.inputLabel1)}
            type="password"
            error={errors.password}
            whiteLabel={windowWidth < 1140}
          />

          <Input
            name="confirmPassword"
            value={confirmNewPassword}
            onChange={(e: any) => setConfirmNewPassword(e.target.value)}
            label={t(texts.inputLabel2)}
            type="password"
            whiteLabel={windowWidth < 1140}
            error={
              (newPassword !== confirmNewPassword && 'Password mismatch') || errors.confirmPassword
            }
          />

          <div className={styles.buttonWrap}>
            <Button
              title={t(texts.buttonText)}
              loading={loading}
              onClick={() =>
                dispatch(createNewPassword.request(token, newPassword, confirmNewPassword))
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
